module.exports = __webpack_public_path__ + "static/media/cib_cc-visa.73d3575e.svg";